export default {
  custom: () => import("/home/runner/work/trueblue-web/trueblue-web/layouts/custom.vue"),
  default: () => import("/home/runner/work/trueblue-web/trueblue-web/layouts/default.vue")
}